export enum DialogMessageType {
    ADD_INPUT_RANGE_TAB = 'ADD_INPUT_RANGE_TAB',
    START_CELL_SELECTION = 'START_CELL_SELECTION',
    END_CELL_SELECTION = 'END_CELL_SELECTION',
    ADD_LINK_TO_CELL = 'ADD_LINK_TO_CELL',
    ADD_CUSTOM_BUILT_INDEX_FORMULA_TO_CELL = 'ADD_CUSTOM_BUILT_INDEX_FORMULA_TO_CELL',
    CLOSE = 'CLOSE',
    OPEN_PLACEHOLDER = 'OPEN_PLACEHOLDER',
    UPDATE_ADDRESS = 'UPDATE_ADDRESS',
    EXTRACT_SLIDES = 'EXTRACT_SLIDES'
}

export interface DialogMessage {
    action: DialogMessageType;
    data?: any;
} 